module.exports = __webpack_public_path__ + "static/media/guitars.977e8564.svg";